import React, {useState} from 'react'

import Content from '../content'
import VideoPlayer from '../videoPlayer'
import './sidebar.css'


export default function SideBar({sidebarInfo}) {
    const [videoIsOpen, setVideoIsOpen] = useState(false)
    const apiURL = process.env.REACT_APP_API_URL

    const handleVideoPlayer = (isOpen) => {
        setVideoIsOpen(isOpen)
    }
    
    if(sidebarInfo === null) return ( '' )

    const videoURL = sidebarInfo.Video && sidebarInfo.Video.data ? apiURL + sidebarInfo.Video.data.attributes.url : ''

    return (
        <div>
            <div className="sidebar open">
                <img className="logo" src="/hpe-logo.png" alt="HPE Enterprise logo" />
                <span className='preheader'>{sidebarInfo.Preheader}</span>
                <h1>{sidebarInfo.Title}</h1>
                <Content content={sidebarInfo.Content} containerClass="content-container" />
                {videoURL && (
                    <button className='discoverMore' onClick={() => setVideoIsOpen(true)} >HPE in Telco</button>
                )}
            </div>
            {videoIsOpen && (
                <VideoPlayer 
                    url={videoURL}
                    title={sidebarInfo.VideoTitle}
                    subTitle={sidebarInfo.VideoSubTitle}
                    handleVideoPlayer={handleVideoPlayer}
                />
            )}
        </div>
    )
}